import { render, staticRenderFns } from "./PassionsSection.vue?vue&type=template&id=93efc08e&lang=pug&"
import script from "./PassionsSection.vue?vue&type=script&lang=ts&"
export * from "./PassionsSection.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports